(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fleet-daily-trip', {
            parent: 'import',
            url: '/fleet-daily-trip?page&sort&date&technicien&withoutTechnicien',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.fleetDailyTrip.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trips.html',
                    controller: 'FleetDailyTripController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                date: null,
                technicien: null,
                withoutTechnicien: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        date: $stateParams.date,
                        technicien: $stateParams.technicien,
                        withoutTechnicien: $stateParams.withoutTechnicien
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fleetDailyTrip');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fleet-daily-trip.new', {
            parent: 'fleet-daily-trip',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trip-dialog.html',
                    controller: 'FleetDailyTripDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fileName: null,
                                file: null,
                                fileContentType: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fleet-daily-trip', null, { reload: 'fleet-daily-trip' });
                }, function() {
                    $state.go('fleet-daily-trip');
                });
            }]
        })
        .state('fleet-daily-trip.edit', {
            parent: 'fleet-daily-trip',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trip-edit-dialog.html',
                    controller: 'FleetDailyTripEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['FleetDailyTrip', function(FleetDailyTrip) {
                            return FleetDailyTrip.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-daily-trip', null, { reload: 'fleet-daily-trip' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fleet-daily-trip.delete', {
            parent: 'fleet-daily-trip',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trip-delete-dialog.html',
                    controller: 'FleetDailyTripDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FleetDailyTrip', function(FleetDailyTrip) {
                            return FleetDailyTrip.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-daily-trip', null, { reload: 'fleet-daily-trip' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
